import { ReactNode } from 'react';
import {
	EventKeys,
	EventCategory,
	EventValues,
} from '../../../../services/analytics';
import AbstractAnalytics from '../../../../services/abstract-analytics';

export type directions = 'LTR' | 'RTL' | undefined;
export type position = 'CENTER' | 'END' | undefined;

export interface ITooltip {
	children: ReactNode;
	className?: string;
	icon?: ReactNode | string;
	modal?: boolean;
	scroll?: boolean;
	title?: string;
	event?: 'click' | 'hover';
	fieldname?: string;
}

export const sendTooltipAnalytics = (
	analytics: AbstractAnalytics, 
	href: string, 
	fieldname: string
) => {
	//TODO: make the Event action generic based on pathname
	analytics.sendEvent({
		[EventKeys.EventCategory]: EventCategory.Help,
		[EventKeys.EventAction]: href.includes('forms')
			? EventValues.ProfileForm
			: EventCategory.Landing,
		[EventKeys.EventLabel]: `Info Popup - ${fieldname}`,
		[EventKeys.InfoPopup]: fieldname,
	});
};
